import {Colors} from 'components/common/useBaseStyle'
import {darken} from 'polished'
import styled, {css} from 'styled-components'

export interface PrimaryOutlineButtonProps {
  disabled?: boolean
  fullWidth?: boolean
  flex?: boolean
}

export const PrimaryOutlineButton = styled.button<PrimaryOutlineButtonProps>`
  user-select: none;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  box-sizing: border-box;
  width: ${({fullWidth = false}) => (fullWidth ? '100%' : 'auto')};
  flex: ${({flex = false}) => (flex ? '1' : 'none')};
  color: ${Colors.primary};
  background-color: ${Colors.white};
  border: 1px solid ${Colors.primary};
  border-radius: 3px;
  padding: 7px 9px;

  & .Icon {
    margin-right: 5px;
  }

  &:hover {
    opacity: 0.8;
  }

  &:active {
    color: ${darken(0.1, Colors.primary)};
    border-color: ${darken(0.1, Colors.primary)};
  }

  ${({disabled = false}) =>
    disabled
      ? css`
          pointer-events: none;
          cursor: default;
          color: rgba(0, 0, 0, 0.12);
          border: 1px solid rgba(0, 0, 0, 0.12);
        `
      : null}
`
